// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2J9b_","title":"Header_title__qqFAt","side":"Header_side__1-8lk"};